export default __webpack_public_path__ + "static/media/ProductSans-Light.0fa7666a.woff";